import { PopupDirection } from 'lego-on-react';
import React from 'react';

import { HintPopup } from '../HintPopup/HintPopup';
import { QuestionLink } from '../QuestionLink/QuestionLink';

interface Props {
    directions?: PopupDirection[];
    hint: React.ReactNode;
}

export const Hint: React.FC<Props> = ({ directions, hint }) => {
    return (
        <HintPopup directions={directions} hint={hint}>
            <QuestionLink />
        </HintPopup>
    );
};
